module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f4dc047080ceaf573618136674be653a.png";